import { merge } from "lodash";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import TruncatedHtml from "../../user_content/truncated_html";

export default GrComponentFactory.createClass({
  displayName: "UserQuoteHeader",

  propTypes: {
    quote: GrPropTypes.quote().isRequired,
  },

  getQuoteAuthor(quote) {
    return merge({}, quote.author, {
      viewableName: quote.author.name,
    });
  },

  render() {
    const quote = this.props.quote;
    const quoteAuthor = this.getQuoteAuthor(quote);

    return <div>
      <TruncatedHtml {...quote.body} html={`“${quote.body.html}”`} />
      <div>
          <a href={quoteAuthor.profileUrl}
             className="gr-book gr-book__authorLink gr-hyperlink gr-hyperlink--bold">
            {quoteAuthor.viewableName}
          </a>
        </div>
      </div>;
  },
});
